class MegaMenu {
  constructor() {
    this.triggers = [...document.querySelectorAll("[data-mega-trigger]")];
    this.panels = [...document.querySelectorAll("[data-mega-panel]")];
    this.fade = document.querySelector("[data-mega-fade]");
    this.header = document.querySelector(".header");

    if (!this.triggers.length) return;

    this.bind();
  }

  bind() {
    this.triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        const handle = trigger.dataset.megaTrigger;
        const isOpen = trigger.getAttribute("aria-expanded") === "true";
        this.closeAll();
        if (!isOpen) this.open(handle);
      });
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") this.closeAll();
    });

    document.addEventListener("click", (e) => {
      if (this.header && !this.header.contains(e.target)) this.closeAll();
    });

    this.fade?.addEventListener("click", () => this.closeAll());
  }

  open(handle) {
    const panel = this.panels.find((p) => p.dataset.megaPanel === handle);
    const trigger = this.triggers.find((t) => t.dataset.megaTrigger === handle);
    if (!panel) return;

    panel.hidden = false;
    requestAnimationFrame(() => panel.classList.add("is-open"));
    trigger?.setAttribute("aria-expanded", "true");
    panel.querySelector("[data-search-input]")?.focus();

    if (this.fade) {
      this.fade.hidden = false;
      requestAnimationFrame(() => this.fade.classList.add("is-open"));
    }
    document.body.classList.add("nav-lock");
    this.isOpen = true;
  }

  closeAll() {
    this.panels.forEach((p) => {
      if (p.hidden) return;
      p.classList.remove("is-open");
      setTimeout(() => {
        if (!p.classList.contains("is-open")) p.hidden = true;
      }, 300);
    });
    this.triggers.forEach((t) => t.setAttribute("aria-expanded", "false"));
    if (this.fade) {
      this.fade.classList.remove("is-open");
      this.fade.hidden = true;
    }
    document.body.classList.remove("nav-lock");
    this.isOpen = false;
  }
}

class NavigationDrawer {
  constructor() {
    this.drawer = document.getElementById("nav-drawer");
    this.burger = document.querySelector(".header__burger");

    if (!this.drawer || !this.burger) return;

    this.subPanels = [...this.drawer.querySelectorAll(".nav-drawer__panel--sub")];
    this.bind();
  }

  bind() {
    this.burger.addEventListener("click", () => {
      const isOpen = this.burger.getAttribute("aria-expanded") === "true";
      isOpen ? this.close() : this.open();
    });

    this.drawer.querySelectorAll("[data-nav-drill]").forEach((btn) => {
      btn.addEventListener("click", () => this.drillIn(btn.dataset.navDrill, btn));
    });

    this.drawer.querySelectorAll("[data-nav-back]").forEach((btn) => {
      btn.addEventListener("click", () => this.drillOut());
    });

    // hand off to the search overlay
    this.drawer.querySelectorAll("[data-mega-trigger]").forEach((btn) => {
      btn.addEventListener("click", () => this.close());
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") this.close();
    });
  }

  open() {
    this.drawer.hidden = false;
    this.burger.setAttribute("aria-expanded", "true");
    document.body.classList.add("nav-lock");
  }

  close() {
    this.drawer.hidden = true;
    this.burger.setAttribute("aria-expanded", "false");
    document.body.classList.remove("nav-lock");
    this.drillOut();
  }

  drillIn(handle, trigger) {
    const panel = this.subPanels.find((p) => p.dataset.navPanel === handle);
    if (!panel) return;

    panel.hidden = false;
    requestAnimationFrame(() => panel.classList.add("is-open"));
    trigger?.setAttribute("aria-expanded", "true");
  }

  drillOut() {
    this.subPanels.forEach((p) => {
      p.classList.remove("is-open");
      p.hidden = true;
    });
    this.drawer.querySelectorAll("[data-nav-drill]").forEach((btn) => {
      btn.setAttribute("aria-expanded", "false");
    });
  }
}

class HeaderScroll {
  constructor() {
    this.header = document.querySelector(".header");
    this.announcementBar = document.querySelector(".announcement-bar");

    if (!this.header) return;

    this.ticking = false;
    this.bindEvents();
    this.handleScroll();
  }

  bindEvents() {
    window.addEventListener("scroll", () => {
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          this.handleScroll();
          this.ticking = false;
        });

        this.ticking = true;
      }
    });
  }

  handleScroll() {
    const scrolled = window.scrollY > 8;
    this.announcementBar?.classList.toggle("announcement-bar--hidden", scrolled);
    document.body.classList.toggle("page-scrolled", scrolled);
  }
}

class PredictiveSearch {
  constructor() {
    this.input = document.querySelector("[data-search-input]");
    this.results = document.querySelector("[data-search-results]");
    this.popular = document.querySelector("[data-search-popular]");

    if (!this.input || !this.results) return;

    this.searchUrl = document.body.dataset.searchUrl || "/search";
    this.timer = null;
    this.seq = 0;

    this.input.addEventListener("input", () => {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.query(this.input.value.trim()), 250);
    });
  }

  async query(q) {
    const seq = ++this.seq;

    if (q.length < 2) {
      this.results.hidden = true;
      this.results.innerHTML = "";
      if (this.popular) this.popular.hidden = false;
      return;
    }

    try {
      const url = `${this.searchUrl}/suggest?q=${encodeURIComponent(q)}&resources[type]=product&section_id=predictive-search`;
      const res = await fetch(url);
      if (!res.ok || seq !== this.seq) return;

      const text = await res.text();
      if (seq !== this.seq) return;

      const doc = new DOMParser().parseFromString(text, "text/html");
      const section = doc.querySelector(".shopify-section") || doc.body;
      this.results.innerHTML = section.innerHTML;
      this.results.hidden = false;
      if (this.popular) this.popular.hidden = true;
    } catch (e) {
      /* network error — keep whatever is shown */
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new MegaMenu();
  new NavigationDrawer();
  new HeaderScroll();
  new PredictiveSearch();
});
